import { useSelector } from "react-redux";
import {
  Box,
  Pagination,
  Snackbar,
  Alert,
  CircularProgress,
} from "@mui/material";
import {
  SessionsTable,
  SessionsControls,
  useSessionsAnalytics,
} from "./sessions";

const RecentVisits = ({
  onSwitchTab,
  onSetMessageRecipient,
  onSetUserSearchTerm,
}) => {
  const { recentVisits, loading } = useSelector((state) => state.admin);
  const {
    searchTerm,
    sortBy,
    sortOrder,
    page,
    rowsPerPage,
    copyFeedback,
    processedSessions,
    paginatedSessions,
    setSearchTerm,
    setRowsPerPage,
    setPage,
    setCopyFeedback,
    handleSort,
    copyToClipboard,
  } = useSessionsAnalytics(recentVisits);

  const handleMessageUser = (userId) => {
    if (onSwitchTab && onSetMessageRecipient) {
      onSwitchTab("6");
      onSetMessageRecipient(userId);
    }
  };

  const handleViewUser = (userId) => {
    if (onSwitchTab && onSetUserSearchTerm) {
      onSwitchTab("3");
      onSetUserSearchTerm(userId);
    }
  };

  if (loading?.sessions) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: 300,
        }}
      >
        <CircularProgress size={64} />
      </Box>
    );
  }

  return (
    <Box>
      {/* Search and Controls */}
      <SessionsControls
        searchTerm={searchTerm}
        onSearchChange={setSearchTerm}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={setRowsPerPage}
        totalSessions={processedSessions.length}
      />

      {/* Sessions Table */}
      <SessionsTable
        sessions={paginatedSessions}
        sortBy={sortBy}
        sortOrder={sortOrder}
        onSort={handleSort}
        onCopyUserId={copyToClipboard}
        onMessageUser={handleMessageUser}
        onViewUser={handleViewUser}
      />

      {/* Pagination */}
      {processedSessions.length > rowsPerPage && (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
          <Pagination
            count={Math.ceil(processedSessions.length / rowsPerPage)}
            page={page}
            onChange={(e, newPage) => setPage(newPage)}
            color="primary"
            showFirstButton
            showLastButton
          />
        </Box>
      )}

      {/* Copy feedback */}
      <Snackbar
        open={copyFeedback}
        autoHideDuration={2000}
        onClose={() => setCopyFeedback(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setCopyFeedback(false)}
          severity="success"
          variant="filled"
        >
          User ID copied to clipboard!
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default RecentVisits;
